export const RECALCULATE_PROFIT_DETAILS = 'RECALCULATE_PROFIT_DETAILS';
